function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Backbone from '@polleverywhere/backbone';
import Segment from './segment';

var Segments = /*#__PURE__*/function (_Backbone$Collection) {
  _inheritsLoose(Segments, _Backbone$Collection);

  function Segments() {
    return _Backbone$Collection.apply(this, arguments) || this;
  }

  var _proto = Segments.prototype;

  _proto.responseCount = function responseCount(opts) {
    if (opts == null) {
      opts = {};
    }

    return this.segmentingOption.responseCount(opts);
  };

  _proto.maxResponseCount = function maxResponseCount(opts) {
    if (opts == null) {
      opts = {};
    }

    return this.segmentingOption.maxResponseCount(opts);
  };

  _createClass(Segments, [{
    key: "model",
    get: function get() {
      return Segment;
    }
  }]);

  return Segments;
}(Backbone.Collection);

export { Segments as default };